<div class="skeleton-form">
  <div *ngFor="let row of skeletonRows" class="skeleton-row">
    <div class="skeleton-item skeleton-label"></div>
    <div class="skeleton-item skeleton-input"></div>
  </div>
</div>